module.exports = __webpack_public_path__ + "img/94844.781f0b55.svg";